import React from 'react';
import { DayPickerRangeController, isInclusivelyBeforeDay } from 'react-dates';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
// Local helpers for this component
import getDateDetails from "./helpers/getDateDetails";
import getAvailability from "./helpers/getAvailability";
import hasAvailability from "./helpers/hasAvailability";

const OverviewCalendar = () => {
  const {
    state,
    dispatch
  } = useStore();
  ;
  const {
    firstMatch,
    focus,
    schedule,
    selectedDate
  } = state;

  const getInitialVisibleMonth = () => {
    let time = moment();

    if (schedule.timeslots.length) {
      time = moment(schedule.timeslots[0].time.start);
    }

    if (!!firstMatch) {
      time = moment(firstMatch);
    }

    return time;
  };

  return /*#__PURE__*/React.createElement(DayPickerRangeController, {
    startDate: null,
    endDate: null,
    onDatesChange: ({
      startDate
    }) => {
      const details = getDateDetails(startDate, schedule);
      dispatch({
        type: 'UPDATE',
        payload: {
          selectedDate: parseInt(moment(startDate).format('x')),
          dateDetails: details,
          dayToRender: startDate
        }
      });
    },
    focusedInput: focus,
    renderDayContents: d => {
      const details = getDateDetails(d, schedule);
      const {
        availabilities,
        timeslots
      } = details;
      const expert = getAvailability('expert', availabilities);
      const client = getAvailability('client', availabilities);
      return /*#__PURE__*/React.createElement("div", {
        className: `day-cell ${new Date(d).getDate() === new Date(selectedDate).getDate() && new Date(d).getMonth() === new Date(selectedDate).getMonth() ? 'selected' : ''}`
      }, /*#__PURE__*/React.createElement("span", {
        className: "dayOfMonth"
      }, `${d.format('D')}`), timeslots.length > 0 ? /*#__PURE__*/React.createElement("span", {
        id: "tsCheck"
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
        className: `info ${timeslots.length > 0 ? '' : 'transparent'} ${hasAvailability(d, expert, client) ? 'outline' : ''}`
      }, client.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dot client"
      }), expert.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "dot expert"
      })));
    },
    daySize: window && window.outerWidth < 768 ? 45 : 55,
    onFocusChange: () => dispatch({
      type: 'UPDATE',
      payload: {
        focus: 'startDate'
      }
    }),
    initialVisibleMonth: getInitialVisibleMonth,
    hideKeyboardShortcutsPanel: true,
    isOutsideRange: day => isInclusivelyBeforeDay(day, moment().subtract(1, 'day')),
    enableOutsideDays: true
  });
};

export default OverviewCalendar;